module.exports = __webpack_public_path__ + "static/bannsanc-bf45199567329eff7974016e13d789e1.png";